// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".meta-model{position:relative}.meta-model a{color:#337ab7!important;cursor:pointer}.meta-model .context-menu{position:fixed;padding:0;width:132px;height:142px;border-radius:4px;border:1px solid #ebeef5}.meta-model .context-menu .btn{cursor:pointer}.meta-model .basic-container{padding-left:0!important;padding-right:0!important}.meta-model .model-height{height:calc(100vh - 124px)!important;overflow:auto}.meta-model .meta-container{width:calc(79.16667% - 8px);margin-left:8px}", ""]);
// Exports
module.exports = exports;
